import _ from 'lodash';
import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';

import Uuid from '../../../../../support/Uuid';
import ComercioExteriorMercanciaForm from './ComercioExteriorMercanciaForm';
import ComercioExteriorMercanciasList from './ComercioExteriorMercanciasList';

class ComercioExteriorMercanciasManager extends Component {
  state = {}

  handleOnAdd = (data) => {
    const { Mercancias = {} } = this.props.data;
    const { Mercancia = [] } = Mercancias;

    const newData = Mercancia.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnAddFile = (data) => {
    const { Mercancias = {} } = this.props.data;
    const { Mercancia = [] } = Mercancias;

    let newData = _.map(data, (item) => {
      item.id = Uuid.v4();

      return item;
    });

    newData = Mercancia.concat(newData);

    this.handleOnListChange(newData);
  }

  handleOnListChange = (data) => {
    const mercancias = this.props.data.Mercancias || {};

    this.props.onChange({
      ...this.props.data,
      Mercancias: {
        ...mercancias,
        Mercancia: data
      }
    });
  }

  handleOnChange = (data) => {
    const mercancias = this.props.data.Mercancias || {};

    this.props.onChange({
      ...this.props.data,
      Mercancias: {
        ...mercancias,
        ...data
      }
    });
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item },
      key: 'form'
    }, () => {
      this.setState({
        data: undefined,
        key: 'form'
      });
    });
  }

  handleOnDelete = () => {
    this.props.onChange({
      ...this.props.data,
      Mercancias: {}
    });
  }

  render() {
    const { data } = this.state;
    const { Mercancias = {} } = this.props.data;
    const { Mercancia = [] } = Mercancias;

    return (
      <div className="pb-4">
        <div>
          <strong className="text-black text-upper">Mercancias</strong>
        </div>

        <div className="section">
          <div className="pt-2">
            <ComercioExteriorMercanciaForm
              data={ data }
              onAdd={ this.handleOnAdd }
              onAddFile={ this.handleOnAddFile }
            />
          </div>

          <div className="pt-2">
            <ComercioExteriorMercanciasList
              data={ Mercancia }
              onEdit={ this.handleOnEdit }
              onChange={ this.handleOnListChange }
            />
          </div>

          <Row>
            <Col>
              <Button variant="danger"
                disabled={ Mercancia.length === 0 }
                onClick={ this.handleOnDelete }
              >
                Eliminar mercancías
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default ComercioExteriorMercanciasManager;